import { NgOptimizedImage } from '@angular/common';
import { Component, Input, OnInit, computed, inject, input, output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { LinkComponent } from '@teamfoster/sdk/button';
import { ShowCookieSettings } from '@teamfoster/sdk/cookie-ngrx';
import { FromDictionaryPipe, LanguageService } from '@teamfoster/sdk/dictionary-ngrx';
import { MenuItem } from '@teamfoster/sdk/menu-ngrx';
import { link } from 'node:fs';
import { url } from 'node:inspector';
import { ContentPage } from 'src/app/content/models';
import { Portal } from 'src/app/portals/models';

import { SocialChannel } from 'src/app/social-media/models';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [FromDictionaryPipe, LinkComponent, NgOptimizedImage],
})
export class FooterComponent implements OnInit {
  private lang = inject(LanguageService);
  private dict = new FromDictionaryPipe(this.lang);

  domain = input<string>('');
  menu = input<MenuItem[]>([]);
  socials = input<SocialChannel[]>([]);
  portals = input<Partial<Portal>[]>([]);
  activePortal = input<Portal | null>(null);
  schema = input<any>({
    '@context': 'http://schema.org',
    '@type': this.dict.transform('footer-json-ld-meta-type'),
    'name': this.dict.transform('meta-titel'),
    'url': this.domain,
    'logo': `${this.domain}/assets/gfx/logo.svg`,
    'contactPoint': {
      '@type': 'ContactPoint',
      'email': this.dict.transform('contact-email'),
      'contactType': 'customer service',
    },
    'sameAs': [],
  });

  openCookiePreferences = output<void>();

  year = new Date().getFullYear();

  themeIsLight = computed(() => this.activePortal()?.bodyCssClass === 'light');

  ngOnInit(): void {
    this.socials().forEach(s => {
      const socialLink = s; // to do config with social buttons
      this.schema().sameAs.push(socialLink);
    });
  }
}
